/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
let Shape3DSphere = class Shape3DSphere extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createSphere(shape.radius, shape.widthSegments, shape.heightSegments);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration);
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            radius: s.x * source.radius,
            widthSegments: source.widthSegments,
            heightSegments: source.heightSegments,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DSphere = tslib_1.__decorate([
    Shape('Shape3D.Sphere'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DSphere);
export { Shape3DSphere };
//# sourceMappingURL=Shape3DSphere.js.map